import { render, staticRenderFns } from "./SearchProd.vue?vue&type=template&id=2ccc2156&scoped=true&"
import script from "./SearchProd.vue?vue&type=script&lang=js&"
export * from "./SearchProd.vue?vue&type=script&lang=js&"
import style0 from "./SearchProd.vue?vue&type=style&index=0&id=2ccc2156&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccc2156",
  null
  
)

export default component.exports